<template>
  <b-modal ref="paymentHistoryModal" size="lg" hide-footer centered modal-scrollable title="Payment History">
    <div class="container">
      <div class="row">
        <div class="col">
          <h5>Completed</h5>
        </div>
      </div>
      <div class="row" v-for="(receipt, index) in getLenderPaymentHistory" v-bind:key="index" v-bind:style="{ 'background-color': backgroundColors[index % 2] }">
        <div class="col">
          <div class="row">
            <div class="col-3">
              <p>{{ months[parseInt(receipt.date.split('-')[1]) -1] + ' ' + receipt.date.split('T')[0].split('-')[2] + ', ' + receipt.date.split('-')[0] }}</p>
            </div>
            <div class="col-2">
              <p>${{ receipt.amount }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <p>{{ receipt.card_type }} ****{{ receipt.card_last_four }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <p>Order #{{ receipt.id }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      backgroundColors: ['gainsboro', 'white'],
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    }
  },
  computed: {
    ...mapGetters('lender', [
      'getLenderPaymentHistory'
    ])
  },
  methods: {
    ...mapActions('lender', [
      'getPaymentHistory'
    ])
  },
  async mounted () {
    await this.getPaymentHistory()
  }
}
</script>

<style scoped>
p {
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/lenderProfile/PaymentHistoryModal.vue